module.exports = __webpack_public_path__ + "static/media/ax.a860707b.jpeg";